<tk-vehicle-list-filter
  #filtersComponent
  [mode]="'lite'"
  [isEtoll]="isEtoll"
  [isTacho]="isTachoView"
  [filters]="filters"
  [tachoFilters]="tachoFilters"
  (onDisplayFieldChanged)="onDisplayFieldChanged($event)"
  (onHandleOnHeightChanged)="handleOnHeightChanged($event)"
  (onFilterChanged)="onFilterChanged($event)"
  (onFilterTachoChanged)="onFilterTachoChanged($event)"
></tk-vehicle-list-filter>

<div *ngIf="!vehicles" class="skeleton">
  <p-skeleton *ngFor="let item of [1,1,1,1,1,1,1,1,1,1,1]" height="5rem"></p-skeleton>
</div>

<!-- nie znaleziono-->
<div *ngIf="vehicles && vehicles.length == 0 && _currentFilter" class="tk-vehicles-panel-height grid place-items-center">
  <div class="empty-state">
    <div class="empty-state__vehicles-list">
      <img src="/assets/img/empty-state-vehicles-list.svg" alt="">
      <span class="empty-state__vehicles-list__title">
        {{'emptyStateVehiclesListTitle'|translate}}
      </span>
      <span class="empty-state__vehicles-list__description">
        {{'emptyStateVehiclesListDescription'|translate}}
      </span>
    </div>
  </div>
</div>

<!-- jeszcze nie ma-->
<div class="tk-vehicles-panel-height grid place-items-center"
     *ngIf="vehicles && vehicles.length == 0 && !_currentFilter">
  <div class="empty-state">
    <div class="empty-state-image"></div>
    <div class="empty-state-text">{{'vehicles-list.no-vehicles-line1' | translate}}</div>
    <div class="empty-state-desc">
      {{'vehicles-list.no-vehicles-line2' | translate}}<br/>
      {{'vehicles-list.no-vehicles-line3' | translate}}<br/>
      {{'vehicles-list.no-vehicles-line4' | translate}}
    </div>
    <div class="empty-state-address">
      <div>{{'contact.phone-prefix' | translate}} {{'contact.phone' | translate}}</div>
      <div>
        <a href="mailto:{{'contact.email' | translate}}">{{'contact.email' | translate}}</a>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="vehicles && vehicles.length > 0">
  <cdk-virtual-scroll-viewport
    *ngIf="vehicles?.length"
    [itemSize]="isTachoView ? 72 : 88"
    minBufferPx="1440"
    maxBufferPx="1440"
    class="tk-vehicles-panel-height"
    id="cdk-virtual-scroll-vehicles"
  >
    <div
      *cdkVirtualFor="let vehicle of vehicles"
      (click)="onSelect(vehicle)"
      class="vehicle"
    >
      <app-list-vehicle-tacho-item 
        *ngIf="isTachoView; else noTachoView"
        [vehicle]="vehicle"
        [isSelected]="vehicle.Id === _selectedVehicleId"
        [hasBlockerReadPermissionUser]="hasBlockerReadPermissionUser"
      ></app-list-vehicle-tacho-item>

      <ng-template #noTachoView>
        <app-list-vehicle-item
          [vehicle]="vehicle"
          [isSelected]="vehicle.Id === _selectedVehicleId"
          [listDataTypeVisible]="listDataTypeVisible"
          [isEtoll]="isEtoll"
          [hasBlockerReadPermissionUser]="hasBlockerReadPermissionUser"
        ></app-list-vehicle-item>
      </ng-template>
    </div>
  </cdk-virtual-scroll-viewport>
</ng-container>
